import React from "react"
import PropTypes from "prop-types"
import Radium, { keyframes } from "higher-order-components/configured-radium/"

/**
 * Calculate contrasting colour based on background colour
 * @param {String} backgroundColor - Hex colour value
 * @returns {String} Contrasting hex colour value
 */
const checkIconColor = (backgroundColor) => {
  let c = "#000"
  if (backgroundColor !== undefined) {
    c = backgroundColor.substring(1) // strip #
  }
  if (c.length < 6) {
    // convert 3-digit hex to 6-digit
    c =
      c.substr(0, 1) +
      c.substr(0, 1) +
      c.substr(1, 1) +
      c.substr(1, 1) +
      c.substr(2, 1) +
      c.substr(2, 1)
  }
  const rgb = parseInt(c, 16) // convert rrggbb to decimal
  const r = (rgb >> 16) & 0xff // extract red
  const g = (rgb >> 8) & 0xff // extract green
  const b = (rgb >> 0) & 0xff // extract blue
  const brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b // per ITU-R BT.709

  let iconColor = "#fff"
  if (brightness > 120) {
    iconColor = "#101010"
  }
  return iconColor
}

/**
 * Animated Check Icon component
 * @param {object} props - Component props
 * @param {String} props.color - hex background color to calculate contrasting check colour.
 * @returns {ReactElement} React Component
 */
const AnimatedCheckIcon = props => (
  <div style={styles.base} data-test="check-icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11" style={{ display: "block" }}>
      <title>check</title>
      <polygon
        style={{ fill: checkIconColor(props.color) }}
        points="9.57 0 4.67 8.01 1.32 4.08 0 5.14 4.84 11 11 0.9 9.57 0" />
    </svg>
  </div>
)

AnimatedCheckIcon.propTypes = {
  color: PropTypes.string
}

export default Radium(AnimatedCheckIcon)

const fadeInKeyframes = keyframes({
  from: {
    opacity: 0,
    transform: "rotate(-45deg)"
  }
})

const styles = {
  base: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: ".7em",
    width: ".7em",
    pointerEvents: "none",
    animation: "x .25s",
    transformOrigin: "50% 50%",
    animationName: fadeInKeyframes
  }
}



// WEBPACK FOOTER //
// ./src/containers/animated-check-icon/index.jsx